import React from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { cn } from "@/lib/utils";

interface ServiceCarouselProps {
  images: string[];
  className?: string;
}

export function ServiceCarousel({ images, className }: ServiceCarouselProps) {
  const [emblaRef] = useEmblaCarousel({ loop: true }, [Autoplay({ delay: 3000 })]);

  return (
    <div className={cn("overflow-hidden rounded-xl border border-slate-200 shadow-sm bg-slate-50", className)} ref={emblaRef}>
      <div className="flex h-full">
        {images.map((src, index) => (
          <div className="flex-[0_0_100%] min-w-0 relative h-full" key={index}>
            <div className="w-full h-full relative flex items-center justify-center p-2">
              <img
                src={src}
                alt={`Service slide ${index + 1}`}
                className="max-w-full max-h-full object-contain rounded-sm"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = "https://images.unsplash.com/photo-1581092921461-eab62e97a783?auto=format&fit=crop&w=800&q=80"; // Fallback
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
